import React from 'react';
import { useEditorContext } from '../../context/editor-context';
import { useResponsiveSizes } from '../../../../hooks/use-responsive-sizes';
import { C } from '../../constants/design-tokens';
import { getAvatarEntry, resolutionToAspectRatio } from '../../utils/avatar-lookups';
import type { Plano } from '../../constants/avatar-matrix';
import { RESOLUTIONS } from './resolution-selector';
import { PlayCircleOutlined } from '@ant-design/icons';

const ASPECT_RATIOS: Record<string, number> = {
  '16:9': 16 / 9,
  '9:16': 9 / 16,
  '1:1': 1,
  '4:5': 4 / 5
};

export const ScenePreview: React.FC = () => {
  const { scene, selectedResolution } = useEditorContext();
  const { spacing, fontSize, screens } = useResponsiveSizes();

  const resConfig = RESOLUTIONS.find(r => r.id === selectedResolution);
  const aspectRatio = resConfig ? ASPECT_RATIOS[resConfig.aspectRatio] || 16 / 9 : 16 / 9;
  const matrixResolucion = resolutionToAspectRatio(selectedResolution);

  const entry =
    scene?.vestuario && scene?.ambiente && scene?.plano
      ? getAvatarEntry(scene.vestuario, scene.ambiente, matrixResolucion, scene.plano as Plano)
      : null;

  const maxWidth = screens.xs ? 240 : screens.sm ? 280 : 320;

  return (
    <div style={{ marginBottom: spacing.lg }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: spacing.sm,
          paddingBottom: spacing.xs,
          borderBottom: `1px solid ${C.border}`
        }}
      >
        <span
          style={{
            fontSize: fontSize.sm,
            fontWeight: 600,
            textTransform: 'uppercase',
            letterSpacing: 0.6,
            color: C.textLabel
          }}
        >
          Preview - Proximamente
        </span>
      </div>

      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <div
          style={{
            position: 'relative',
            width: '100%',
            maxWidth,
            aspectRatio: String(aspectRatio),
            borderRadius: 8,
            overflow: 'hidden',
            border: `1px solid ${C.border}`,
            background: C.surface
          }}
        >
          {entry ? (
            <>
              <img
                src={entry.url}
                alt={`${entry.vestuario} - ${entry.ambiente} - ${entry.plano}`}
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover'
                }}
              />
              <div
                style={{
                  position: 'absolute',
                  inset: 0,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  background: 'rgba(0, 0, 0, 0.3)',
                  cursor: 'default'
                }}
              >
                <PlayCircleOutlined style={{ fontSize: 48, color: 'rgba(255, 255, 255, 0.7)' }} />
              </div>
            </>
          ) : (
            <div
              style={{
                position: 'absolute',
                inset: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: spacing.md
              }}
            >
              <div style={{ fontSize: fontSize.sm, color: C.textMuted, textAlign: 'center', width: '100%' }}>
                Seleccioná vestuario y entorno para la previsualización
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
